<!-- 
	UpdateFormNew
	props: User
  	role: User
	Called by @/views/Settings to allow user to update account through ClickSpace form
	Does not include ticket packages
-->

<template>
  <div id="form">
    <div class="DialogInsightFormDiv" id="divForm_DIForm_709_26035" style="display:none;background-color:white;padding: 50px;">
      <a name="divForm_DIForm_709_26035_globalErrors_anchor"></a>
      <div class="DialogInsightGlobalErrors" id="divForm_DIForm_709_26035_globalErrors"></div>
      <div class="DialogInsightFormContainer royal" style="font-weight: bold;">
        <div>
          <p class="text-24 gold-1">Your Identification</p>
          <br>
        </div>
        
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Employee ID:</div>
          {{ user.additionalData.employeeId }}
          <div class="DialogInsightInputContainer" style="display:none;">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_EmployeeID" maxlength="8" :value="user.additionalData.employeeId" readonly />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_EmployeeID_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">First Name:</div>
          {{ user.additionalData.firstName || user.additionalData.firstname }}
          <div class="DialogInsightInputContainer" style="display:none;">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_FirstName" maxlength="50" :value="user.additionalData.firstName" readonly />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_FirstName_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Last Name:</div>
          {{ user.additionalData.lastName }}
          <div class="DialogInsightInputContainer" style="display:none;">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_LastName" maxlength="50" :value="user.additionalData.lastName" readonly />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_LastName_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Home Address:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_HomeAddress" maxlength="100" v-model="user.apiData.Profile.AddressLineOne" placeholder="Address" />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_HomeAddress_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">City:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_City" maxlength="50" v-model="user.apiData.Profile.City" placeholder="City" />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_City_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Postal code:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_PostalCode" maxlength="7" v-model="user.apiData.Profile.PostalCode" placeholder="Postal Code" />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_PostalCode_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Mobile phone:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_MobilePhone" maxlength="10" v-model="user.apiData.Profile.MobilePhone" placeholder="Mobile Phone " />
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_MobilePhone_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Home phone:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_HomePhone" maxlength="10" v-model="user.apiData.Profile.HomePhone" placeholder="Home Phone"/>
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_HomePhone_errors"></div>
          </div>
        </div>

        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Email:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_EMail" maxlength="125" :value="user.data.email" readonly/>
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_EMail_errors"></div>
          </div>
        </div>

        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Alternate Email:</div>
          <div class="DialogInsightInputContainer">
            <input type="text" class="DialogInsightFormInput" id="DIField_26035_f_AlternateEmail" maxlength="125" v-model="user.apiData.Profile.AlternateEmail" placeholder="Alternate Email"/>
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_AlternateEmail_errors"></div>
          </div>
        </div>
        
        <div>
          <br>
          <p class="text-24 gold-1">Your Payroll Selection & Designation</p>
          <br>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Payroll Selection:</div>
          <div class="DialogInsightInputContainer">
             <div id="DIField_26035_f_PayrollSelection">
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection0" v-model="company" value="ACA"/>
              <label for="DIField_26035_f_PayrollSelection0">Acute Care Alberta</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection1" v-model="company" value="CHR"/>
              <label for="DIField_26035_f_PayrollSelection1">Alberta Health Services</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection2" v-model="company" value="LAB"/>
              <label for="DIField_26035_f_PayrollSelection2">Alberta Precision Labs</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection3" v-model="company" value="ALA"/>
              <label for="DIField_26035_f_PayrollSelection3">Assisted Living Alberta</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection4" v-model="company" value="CW"/>
              <label for="DIField_26035_f_PayrollSelection4">Carewest</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection5" v-model="company" value="COV"/>
              <label for="DIField_26035_f_PayrollSelection5">Covenant Health</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection6" v-model="company" value="HSS"/>
              <label for="DIField_26035_f_PayrollSelection6">Health Shared Services</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection7" v-model="company" value="PCA"/>
              <label for="DIField_26035_f_PayrollSelection7">Primary Care Alberta</label>
              <br/>
              <input type="radio" class="DialogInsightFormInput" name="DIField_26035_f_PayrollSelection" id="DIField_26035_f_PayrollSelection8" v-model="company" value="RA"/>
              <label for="DIField_26035_f_PayrollSelection8">Recovery Alberta</label>
              <br/>
            </div>
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_PayrollSelection_errors"></div>
          </div>
        </div>
        
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField">Select Your New Designation:</div>
          <div class="DialogInsightInputContainer">
            <select class="DialogInsightFormInput" id="DIField_26035_f_NewDesignation" v-model="beneficiary">
              <option value="Addiction Services across Alberta" style="color: #000000;">Addiction Services across Alberta</option>
              <option value="Airdrie Community Health Centre" style="color: #000000;">Airdrie Community Health Centre</option>
              <option value="Alberta Children’s Hospital" style="color: #000000;">Alberta Children’s Hospital</option>
              <option value="Alberta Hospital, Edmonton" style="color: #000000;">Alberta Hospital, Edmonton</option>
              <option value="Alberta Women&#39;s Health Foundation" style="color: #000000;">Alberta Women&#39;s Health Foundation</option>
              <option value="Anzac Community Clinic" style="color: #000000;">Anzac Community Clinic</option>
              <option value="Arthur J.E. Child Comprehensive Cancer Centre" style="color: #000000;">Arthur J.E. Child Comprehensive Cancer Centre</option>
              <option value="Banff Mineral Springs Hospital (Banff)" style="color: #000000;">Banff Mineral Springs Hospital (Banff)</option>
              <option value="Barrhead Community Cancer Centre" style="color: #000000;">Barrhead Community Cancer Centre</option>
              <option value="Bassano Health Centre" style="color: #000000;">Bassano Health Centre</option>
              <option value="Beaumont Public Health Centre" style="color: #000000;">Beaumont Public Health Centre</option>
              <option value="Beaverlodge Municipal Hospital" style="color: #000000;">Beaverlodge Municipal Hospital</option>
              <option value="Big Country Hospital" style="color: #000000;">Big Country Hospital</option>
              <option value="Bonnyville Community Cancer Centre" style="color: #000000;">Bonnyville Community Cancer Centre</option>
              <option value="Bonnyville Health Centre" style="color: #000000;">Bonnyville Health Centre</option>
              <option value="Bow Valley Community Cancer Centre" style="color: #000000;">Bow Valley Community Cancer Centre</option>
              <option value="Brooks Community Health/Home Care" style="color: #000000;">Brooks Community Health/Home Care</option>
              <option value="Brooks Health Centre" style="color: #000000;">Brooks Health Centre</option>
              <option value="Calgary Community Health Centres" style="color: #000000;">Calgary Community Health Centres</option>
              <option value="Calgary Health Centres (SMCHC, SCHC, ECHC, RRDTC)" style="color: #000000;">Calgary Health Centres (SMCHC, SCHC, ECHC, RRDTC)</option>
              <option value="Camrose Community Cancer Centre" style="color: #000000;">Camrose Community Cancer Centre</option>
              <option value="Cancer Care Alberta" style="color: #000000;">Cancer Care Alberta</option>
              <option value="Canmore General Hospital" style="color: #000000;">Canmore General Hospital</option>
              <option value="Cardston Health Centre" style="color: #000000;">Cardston Health Centre</option>
              <option value="Carewest" style="color: #000000;">Carewest</option>
              <option value="Central Alberta Cancer Centre (Red Deer)" style="color: #000000;">Central Alberta Cancer Centre (Red Deer)</option>
              <option value="CK Hui Heart Centre" style="color: #000000;">CK Hui Heart Centre</option>
              <option value="Claresholm Centre for Mental Health and Addictions" style="color: #000000;">Claresholm Centre for Mental Health and Addictions</option>
              <option value="Claresholm General Hospital (CGH)" style="color: #000000;">Claresholm General Hospital (CGH)</option>
              <option value="Claresholm Mental Health Clinic" style="color: #000000;">Claresholm Mental Health Clinic</option>
              <option value="Community Health - Claresholm Health Unit" style="color: #000000;">Community Health - Claresholm Health Unit</option>
              <option value="Conklin Community Clinic" style="color: #000000;">Conklin Community Clinic</option>
              <option value="Coronation Hospital &amp; Care Centre" style="color: #000000;">Coronation Hospital &amp; Care Centre</option>
              <option value="Cross Cancer Institute" style="color: #000000;">Cross Cancer Institute</option>
              <option value="Crowsnest Pass Health Centre" style="color: #000000;">Crowsnest Pass Health Centre</option>
              <option value="Daysland Health Centre" style="color: #000000;">Daysland Health Centre</option>
              <option value="Devon General Hospital" style="color: #000000;">Devon General Hospital</option>
              <option value="Didsbury District Health Services" style="color: #000000;">Didsbury District Health Services</option>
              <option value="Drayton Valley Community Cancer Centre" style="color: #000000;">Drayton Valley Community Cancer Centre</option>
              <option value="Drumheller Community Cancer Centre" style="color: #000000;">Drumheller Community Cancer Centre</option>
              <option value="Drumheller Health Centre" style="color: #000000;">Drumheller Health Centre</option>
              <option value="Edmonton General Continuing Care Centre" style="color: #000000;">Edmonton General Continuing Care Centre</option>
              <option value="Edson Healthcare Centre" style="color: #000000;">Edson Healthcare Centre</option>
              <option value="Elnora Health Centre" style="color: #000000;">Elnora Health Centre</option>
              <option value="EMS Foundation" style="color: #000000;">EMS Foundation</option>
              <option value="Eye Institute of Alberta" style="color: #000000;">Eye Institute of Alberta</option>
              <option value="Fairview Health Complex" style="color: #000000;">Fairview Health Complex</option>
              <option value="Fairview Homecare" style="color: #000000;">Fairview Homecare</option>
              <option value="Foothills Medical Centre" style="color: #000000;">Foothills Medical Centre</option>
              <option value="Fort Macleod Health Centre" style="color: #000000;">Fort Macleod Health Centre</option>
              <option value="Fort McKay Health Centre" style="color: #000000;">Fort McKay Health Centre</option>
              <option value="Fort McMurray Community Cancer Centre" style="color: #000000;">Fort McMurray Community Cancer Centre</option>
              <option value="Fort McMurray Queens Street Mental Health" style="color: #000000;">Fort McMurray Queens Street Mental Health</option>
              <option value="Fort McMurray Recovery Centre" style="color: #000000;">Fort McMurray Recovery Centre</option>
              <option value="Fort McMurray Timberlea Mental Health Centre" style="color: #000000;">Fort McMurray Timberlea Mental Health Centre</option>
              <option value="Fort Saskatchewan Community Hospital" style="color: #000000;">Fort Saskatchewan Community Hospital</option>
              <option value="Glenrose Rehabilitation Hospital" style="color: #000000;">Glenrose Rehabilitation Hospital</option>
              <option value="Grande Prairie Cancer Centre" style="color: #000000;">Grande Prairie Cancer Centre</option>
              <option value="Grande Prairie Regional Hospital" style="color: #000000;">Grande Prairie Regional Hospital</option>
              <option value="Grey Nuns Hospital" style="color: #000000;">Grey Nuns Hospital</option>
              <option value="Grimshaw/Berwyn Community Health Care Centre" style="color: #000000;">Grimshaw/Berwyn Community Health Care Centre</option>
              <option value="Hardisty Health Centre" style="color: #000000;">Hardisty Health Centre</option>
              <option value="High Prairie Healthcare Complex" style="color: #000000;">High Prairie Healthcare Complex</option>
              <option value="High River Community Cancer Centre" style="color: #000000;">High River Community Cancer Centre</option>
              <option value="High River General Hospital" style="color: #000000;">High River General Hospital</option>
              <option value="High River Health Unit" style="color: #000000;">High River Health Unit</option>
              <option value="Hinton Community Cancer Centre" style="color: #000000;">Hinton Community Cancer Centre</option>
              <option value="Hinton Healthcare Centre" style="color: #000000;">Hinton Healthcare Centre</option>
              <option value="Hythe Continuing Care Centre" style="color: #000000;">Hythe Continuing Care Centre</option>
              <option value="J.B. Wood Continuing Care Centre" style="color: #000000;">J.B. Wood Continuing Care Centre</option>
              <option value="Jack Ady Cancer Centre (Lethbridge)" style="color: #000000;">Jack Ady Cancer Centre (Lethbridge)</option>
              <option value="Kaye Edmonton Clinic" style="color: #000000;">Kaye Edmonton Clinic</option>
              <option value="Killam Health Centre" style="color: #000000;">Killam Health Centre</option>
              <option value="La Crete Continuing Care Centre" style="color: #000000;">La Crete Continuing Care Centre</option>
              <option value="Lac La Biche Healthcare Centre" style="color: #000000;">Lac La Biche Healthcare Centre</option>
              <option value="Lacombe Hospital and Care Centre" style="color: #000000;">Lacombe Hospital and Care Centre</option>
              <option value="Lander Treatment Centre" style="color: #000000;">Lander Treatment Centre</option>
              <option value="Leduc Community Hospital" style="color: #000000;">Leduc Community Hospital</option>
              <option value="Leduc Public Health Centre" style="color: #000000;">Leduc Public Health Centre</option>
              <option value="Lloydminster Community Cancer Centre" style="color: #000000;">Lloydminster Community Cancer Centre</option>
              <option value="Lois Hole Hospital for Women" style="color: #000000;">Lois Hole Hospital for Women</option>
              <option value="Manning Community Health Centre" style="color: #000000;">Manning Community Health Centre</option>
              <option value="Margery E. Yuill Cancer Centre (Medicine Hat)" style="color: #000000;">Margery E. Yuill Cancer Centre (Medicine Hat)</option>
              <option value="Mary Immaculate Care Centre" style="color: #000000;">Mary Immaculate Care Centre</option>
              <option value="Mayerthorpe Health Care Centre" style="color: #000000;">Mayerthorpe Health Care Centre</option>
              <option value="Mazankowski Alberta Heart Institute" style="color: #000000;">Mazankowski Alberta Heart Institute</option>
              <option value="Mental Health Clinics across Alberta" style="color: #000000;">Mental Health Clinics across Alberta</option>
              <option value="Mental Health Foundation" style="color: #000000;">Mental Health Foundation</option>
              <option value="Misericordia Hospital" style="color: #000000;">Misericordia Hospital</option>
              <option value="Nanton Community Health Centre" style="color: #000000;">Nanton Community Health Centre</option>
              <option value="North East Community Health Centre" style="color: #000000;">North East Community Health Centre</option>
              <option value="Northern Alberta" style="color: #000000;">Northern Alberta</option>
              <option value="Northern Lights Regional Health Centre" style="color: #000000;">Northern Lights Regional Health Centre</option>
              <option value="Northwest Health Centre" style="color: #000000;">Northwest Health Centre</option>
              <option value="Oilfields General Hospital (Black Diamond)" style="color: #000000;">Oilfields General Hospital (Black Diamond)</option>
              <option value="Okotoks Health &amp; Wellness Centre" style="color: #000000;">Okotoks Health &amp; Wellness Centre</option>
              <option value="Our Lady of the Rosary Hospital" style="color: #000000;">Our Lady of the Rosary Hospital</option>
              <option value="Oyen Community Health Services" style="color: #000000;">Oyen Community Health Services</option>
              <option value="Paddle Prairie Health Centre" style="color: #000000;">Paddle Prairie Health Centre</option>
              <option value="Peace River Community Cancer Centre" style="color: #000000;">Peace River Community Cancer Centre</option>
              <option value="Peace River Community Health Centre" style="color: #000000;">Peace River Community Health Centre</option>
              <option value="Peter Lougheed Centre" style="color: #000000;">Peter Lougheed Centre</option>
              <option value="Pincher Creek Health Centre" style="color: #000000;">Pincher Creek Health Centre</option>
              <option value="Ponoka Community Health Centre" style="color: #000000;">Ponoka Community Health Centre</option>
              <option value="Ponoka Hospital &amp; Care Centre" style="color: #000000;">Ponoka Hospital &amp; Care Centre</option>
              <option value="Provost Health Centre" style="color: #000000;">Provost Health Centre</option>
              <option value="Queen Elizabeth II Hospital" style="color: #000000;">Queen Elizabeth II Hospital</option>
              <option value="Rainbow Lake Health Centre" style="color: #000000;">Rainbow Lake Health Centre</option>
              <option value="Regional EMS Foundation" style="color: #000000;">Regional EMS Foundation</option>
              <option value="Rocky Mountain House Health Centre" style="color: #000000;">Rocky Mountain House Health Centre</option>
              <option value="Rockyview General Hospital" style="color: #000000;">Rockyview General Hospital</option>
              <option value="Royal Alexandra Hospital" style="color: #000000;">Royal Alexandra Hospital</option>
              <option value="Sherritt Health Services Centre" style="color: #000000;">Sherritt Health Services Centre</option>
              <option value="Silver Willow Lodge - DAL Unit (Nanton)" style="color: #000000;">Silver Willow Lodge - DAL Unit (Nanton)</option>
              <option value="South Health Campus" style="color: #000000;">South Health Campus</option>
              <option value="Southern Alberta" style="color: #000000;">Southern Alberta</option>
              <option value="St. Joseph&#39;s Auxiliary Hospital" style="color: #000000;">St. Joseph&#39;s Auxiliary Hospital</option>
              <option value="St. Joseph&#39;s General Hospital (Vegreville)" style="color: #000000;">St. Joseph&#39;s General Hospital (Vegreville)</option>
              <option value="St. Joseph&#39;s Home (Medicine Hat)" style="color: #000000;">St. Joseph&#39;s Home (Medicine Hat)</option>
              <option value="St. Mary&#39;s Health Care Centre" style="color: #000000;">St. Mary&#39;s Health Care Centre</option>
              <option value="St. Mary&#39;s Hospital (Camrose)" style="color: #000000;">St. Mary&#39;s Hospital (Camrose)</option>
              <option value="St. Michael&#39;s Health Centre (Lethbridge)" style="color: #000000;">St. Michael&#39;s Health Centre (Lethbridge)</option>
              <option value="St. Theresa&#39;s General Hospital" style="color: #000000;">St. Theresa&#39;s General Hospital</option>
              <option value="St. Therese Villa (Lethbridge)" style="color: #000000;">St. Therese Villa (Lethbridge)</option>
              <option value="Stettler Hospital &amp; Care Centre" style="color: #000000;">Stettler Hospital &amp; Care Centre</option>
              <option value="Stollery Children&#39;s Hospital" style="color: #000000;">Stollery Children&#39;s Hospital</option>
              <option value="Strathcona Community Hospital" style="color: #000000;">Strathcona Community Hospital</option>
              <option value="Strathmore Hospital" style="color: #000000;">Strathmore Hospital</option>
              <option value="Sturgeon Community Hospital" style="color: #000000;">Sturgeon Community Hospital</option>
              <option value="Swan Hills Healthcare Centre" style="color: #000000;">Swan Hills Healthcare Centre</option>
              <option value="Sylvan Lake Urgent Care" style="color: #000000;">Sylvan Lake Urgent Care</option>
              <option value="Taber Health Centre" style="color: #000000;">Taber Health Centre</option>
              <option value="Taber Health Foundation - Greatest needs" style="color: #000000;">Taber Health Foundation - Greatest needs</option>
              <option value="The University of Alberta Hospital" style="color: #000000;">The University of Alberta Hospital</option>
              <option value="Thickwood Public Health Clinic" style="color: #000000;">Thickwood Public Health Clinic</option>
              <option value="Thorsby Public Health Centre" style="color: #000000;">Thorsby Public Health Centre</option>
              <option value="Three Hills Health Centre" style="color: #000000;">Three Hills Health Centre</option>
              <option value="Tofield Health Centre" style="color: #000000;">Tofield Health Centre</option>
              <option value="Two Hills Health Centre" style="color: #000000;">Two Hills Health Centre</option>
              <option value="Villa Caritas" style="color: #000000;">Villa Caritas</option>
              <option value="Vulcan Community Health Centre" style="color: #000000;">Vulcan Community Health Centre</option>
              <option value="Wainwright Health Centre" style="color: #000000;">Wainwright Health Centre</option>
              <option value="Westview Health Centre" style="color: #000000;">Westview Health Centre</option>
              <option value="Willow Creek Continuing Care Centre" style="color: #000000;">Willow Creek Continuing Care Centre</option>
              <option value="Worsley Community Health Services" style="color: #000000;">Worsley Community Health Services</option>
              <option value="Youville Home (St. Albert)" style="color: #000000;">Youville Home (St. Albert)</option>
              <option value="Zama Health Centre" style="color: #000000;">Zama Health Centre</option>
            </select>
            <div class="DialogInsightErrorContainer" id="DIField_26035_f_NewDesignation_errors"></div>
          </div>
        </div>
        <div class="DialogInsightFormSubmit">
          <button class="button2 royal" type="button" onclick="DI.Forms.Optin.Client.GetOptinForm('DIForm_709_26035').Submit(this); return false;">Submit</button>
          <img class="DialogInsightFormSubmitLoader" src="https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif" />
        </div>
      </div>

      <div class="DialogInsightFormSuccessDiv" id="divForm_DIForm_709_26035_success" style="padding:10px; display: none;">
        <div class="text-2xl royal">
          Your account information has been updated
        </div>
        <div class="">
          <!--
          <router-link to="/user">
            <CustomButton>View My Profile</CustomButton>
          </router-link>
          -->
          <a href="/user" class="text-center">
            <button
              class="mx-auto rounded-lg my-4 py-2 px-4 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
            >
              VIEW MY PROFILE
            </button>
          </a>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
	import { onMounted } from "@vue/runtime-core";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	export default {
		name: "UpdateOptinFormNew",
		components: {
			CustomButton,
			Loading,
		},
		props: ["user"],
		setup() {
			const formData = {
        formIdent: 'DIForm_709_26035',
        culture: 'en-US',
        idBaseDiv: 'divForm_DIForm_709_26035',
        recaptchaSiteKey: '',
        fields: [
          {"name":"f_EmployeeID","lbl":"Employee ID","id":"DIField_26035_f_EmployeeID","validators":["required"]},
          {"name":"f_FirstName","lbl":"First Name","id":"DIField_26035_f_FirstName","validators":[]},
          {"name":"f_LastName","lbl":"Last Name","id":"DIField_26035_f_LastName","validators":[]},
          {"name":"f_HomeAddress","lbl":"Home Address","id":"DIField_26035_f_HomeAddress","validators":["required"]},
          {"name":"f_City","lbl":"City","id":"DIField_26035_f_City","validators":["required"]},
          {"name":"f_PostalCode","lbl":"Postal code","id":"DIField_26035_f_PostalCode","validators":["required"]},
          {"name":"f_MobilePhone","lbl":"Mobile phone","id":"DIField_26035_f_MobilePhone","validators":[]},
          {"name":"f_HomePhone","lbl":"Home phone","id":"DIField_26035_f_HomePhone","validators":[]},
          {"name":"f_AlternateEmail","lbl":"Alternate Email","id":"DIField_26035_f_AlternateEmail","validators":["email"]},
          {"name":"f_EMail","lbl":"EMail","id":"DIField_26035_f_EMail","validators":["required","email"]},
          {"name":"f_PayrollSelection","lbl":"Payroll Selection","id":"DIField_26035_f_PayrollSelection","validators":["required"],"inputType":"radio"},
          {"name":"f_NewDesignation","lbl":"Select Your New Designation","id":"DIField_26035_f_NewDesignation","validators":["required"],"inputType":"select"}
        ],
        fieldValues: {},
        errorMessages: {"general":"Error in form.","required":"The field {0} is required.","dataType":"The datatype for {0} is invalid.","min":"The minimum value for {0} is {1}.","max":"The maximum value for {0} is {1}.","interval":"The value for {0} must be between {1} and {2}.","inputMask":"The value for {0} does not match the input format.","updateDupeKey":"Update could not be performed as this identifier already exists.","checkInlineErrors":"Please correct the errors below."} ,
        idSuccessDiv: 'divForm_DIForm_709_26035_success',
        mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
        url: '//app.dialoginsight.com/A/WF.ashx',
        idWorkflow: 22044,
        wfKey: '34cG8i',
        nodeKey: 'Optin',
        visible: true
					}
			onMounted(() => {
				// ClickSpace form requirement

				DI.Forms.Optin.Dom.onReady(function() {

						DI.Forms.Optin.Client.InitOptinForm(formData);
					
				});
			});
		},
		data(props) {
			return {
				loading: false,
				timer: false,
				company: props.user.apiData.Profile.PayrollSelection,
				beneficiary:
          props.user.apiData.Profile.NewDesignation ||
          props.user.apiData.Profile.CurrentDesignation,
			};
		},
	};
</script>
<style lang="scss" scoped>
	@import "../assets/styles.scss";

  .royal { color: #1a1f56!important; }
  .gold-1 { color: #C1B59B!important; }

  .button2 {
				background-color: #ffd36c!important;
				color: #E5D876;
				font-weight: 700;
				text-transform: uppercase;
				letter-spacing: 1px;
				border: 1px #1a1f56 solid;
				text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
			}

  .DialogInsightFormDiv input[type="radio"] {
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }

</style>
